import '../styles/Primitives.scss';

export default function Badge({ badgeContent, children, className = '', color, ...props }) {
  return <span className={`ui-badge ${className}`.trim()} {...props}>{children}{badgeContent != null && <span className={`ui-badge__content ui-badge__content--${color || 'default'}`}>{badgeContent}</span>}</span>;
}
